import { Navigate } from '@sorare/routing';

import { FOOTBALL_SCOUTING_CENTER_PLAYERS } from '@sorare/core/src/constants/__generated__/routes';

export const ScoutingCenterPage = () => {
  return <Navigate to={FOOTBALL_SCOUTING_CENTER_PLAYERS} />;
};

export default ScoutingCenterPage;
